import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { Aviso } from '@/shared/ui/Aviso/Aviso'
import { Cargando } from '@/shared/ui/Estados/Cargando'

import { useSesion } from './useSesion'
import type { AccionPermiso } from './contexto'

type PropsRutaProtegida = {
  children: ReactNode
  /** Módulo que la pantalla necesita. Sin él, solo se exige haber ingresado. */
  modulo?: string
  accion?: AccionPermiso
}

/**
 * Guarda de acceso a una pantalla.
 *
 * Es comodidad, no seguridad: aunque alguien esquivara esta guarda escribiendo
 * la dirección a mano, las políticas RLS le devolverían una lista vacía. Lo
 * que evita es enseñarle a una persona una pantalla que no puede usar.
 */
export function RutaProtegida({ children, modulo, accion = 'ver' }: PropsRutaProtegida) {
  const { cargando, perfil, puede } = useSesion()
  const ubicacion = useLocation()

  if (cargando) {
    return <Cargando pantallaCompleta ruta={ubicacion.pathname} />
  }

  if (!perfil) {
    // Se recuerda a dónde iba, para devolverlo ahí después de ingresar.
    return <Navigate to="/ingresar" replace state={{ desde: ubicacion.pathname }} />
  }

  if (modulo && !puede(modulo, accion)) {
    return (
      <Aviso tipo="alerta" titulo="Sin acceso a esta sección">
        Su rol no tiene permiso para ver este módulo. Si cree que debería tenerlo, pídalo al
        administrador del sistema.
      </Aviso>
    )
  }

  return <>{children}</>
}
